import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';
import { AgentTagPropsType } from './index';

const styles: ComponentStylesProps<AgentTagPropsType> = {
  tag: {
    display: 'inline-block',
    font: {
      size: '1rem',
      lineHeight: '2rem',
      weight: 500,
    },
    textTransform: 'uppercase',
    letterSpacing: '0.06rem',
    textAlign: 'center',
    color: colors.neutral[900],
    padding: '0rem 0.8rem',
    borderRadius: '14px',
    verticalAlign: 'bottom',
  },
  tagType_TEAM: { backgroundColor: colors.yellow[100] },
  tagType_AGENT: { backgroundColor: colors.green[100] },
  tagType_ACCOUNT_MANAGER: { backgroundColor: colors.purple[100] },
};

const createStyles = createUseStyles(styles);

export { createStyles };
